var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNumber1IconFpo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 75 75",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#number-1-icon-fpo_svg__clip0_1212_22772)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.5 75C58.21 75 75 58.21 75 37.5S58.21 0 37.5 0C16.789 0 0 16.79 0 37.5S16.789 75 37.5 75z",
  fill: "#F9A13A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5 66C53.24 66 66 53.24 66 37.5S53.24 9 37.5 9 9 21.76 9 37.5 21.76 66 37.5 66z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5 64.5c14.911 0 27-12.088 27-27s-12.089-27-27-27c-14.912 0-27 12.088-27 27s12.088 27 27 27z",
  stroke: "#29398C",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.32 52V31.2l-5.28 4.08-3.48-4.76 9.32-6.84h6.16V52h-6.72z",
  fill: "#29398C"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "number-1-icon-fpo_svg__clip0_1212_22772"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h75v75H0z"
})))));
export default __webpack_public_path__ + "static/number-1-icon-fpo.43c18c2e56d756deba1a4d0ebc7a7277.svg";
export { SvgNumber1IconFpo as ReactComponent };